import React from 'react'
import { useHistory } from 'react-router-dom'
import ProductsListSingleItem from './list-single-item'
import ProductsListCategory from './list-category'
import MaterialsLegend from './../product/materials-legend'

import { useTranslation } from 'react-i18next'

const ProductsList = ({ products, categories, subCategories, purposes, intendedMaterials, filters }) => {

  const history = useHistory()

  const { t } = useTranslation()

  const getCData = (cat) => {
    return categories.filter(c => {
      return c.id === cat.id
    })[0]
  }
  const getSCData = (scat) => {
    if (scat.id === 0) return null
    return subCategories.filter(sc => {
      return sc.id === scat.id
    })[0]
  }

  return (
    <div className="products-list">
      <div className="materials-legend-top">
        <MaterialsLegend/>
      </div>
      {products.length > 0 ? (
        products.map(cProducts => (     
          <ProductsListCategory
            key={cProducts.id}
            category={getCData(cProducts)}
          >
            {cProducts.products.map(product => (
              <ProductsListSingleItem 
                product={product} 
                key={product.id}
                purposes={purposes}
                intendedMaterials={intendedMaterials}
                onClick={() => history.push(`/product/${product.id}`, filters)}
              />
            ))}
          </ProductsListCategory>
        ))
      ):(
        <div className="products-list-empty">
          {t("No matching products found")}
        </div>
      )}
    </div>
  )
}

export default ProductsList